import styled, { ITheme } from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const ArrowButton = styled.div<IWithSize>`
  width: ${({ size }) => (size ? 20 * size : 20)}px;
  height: ${({ size }) => (size ? 20 * size : 20)}px;
  min-width: ${({ size }) => (size ? 20 * size : 20)}px;
  max-height: ${({ size }) => (size ? 20 * size : 20)}px;
  margin-left: ${({ size }) => (size ? 18 * size : 18)}px;
  border-radius: 3px;
  background-color: ${(props: ITheme) =>
    props.theme.colors.palette.pinkishGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: ${(props: ITheme) =>
      props.theme.colors.palette.slateGrey};
  }
`

export default ArrowButton
